var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"weui-switch",class:{'weui-switch-on' : _vm.me_checked_calc===1},attrs:{"value":_vm.value,"shareId":_vm.shareId},on:{"click":function($event){$event.stopPropagation();return _vm.toggle($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260881f9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/input/switch.vue
// module id = null
// module chunks = 